import { Tab, TabsNavigation, TextInput } from "pepsico-ds";
import PropTypes from "prop-types";
import { useState } from "react";
import RadioInputField from "../../jsonForms/radioInputField/RadioInputField";
import { SocialMediaSelectorComponent } from "../../jsonForms/socialMediaSelector/SocialMediaSelector";

const SOCIAL_MEDIA_TABS = [
  { label: "Icons in color", dataKey: "socialLinksColor" },
  { label: "Icons in grayscale", dataKey: "socialLinksGrayscale" },
];

const ICON_SCHEMA = {
  enum: ["COLOR", "GRAYSCALE"],
};

const getIconUiSchema = (readOnly) => ({
  readonly: readOnly,
  options: {
    labelMapping: {
      COLOR: "Color",
      GRAYSCALE: "Grayscale",
    },
  },
});

const IconOptions = ({ label, path, value, readOnly, onChange }) => (
  <RadioInputField
    disabled={readOnly}
    label={label}
    path={path}
    schema={ICON_SCHEMA}
    uiSchema={getIconUiSchema(readOnly)}
    updateValue={(updatedValue) => onChange(path, updatedValue)}
    value={value}
    required
  />
);

IconOptions.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  value: PropTypes.string,
  readOnly: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

const SocialMediaConfigurationView = ({ data, isEdit = false, onChange }) => {
  const [activeTab, setActiveTab] = useState(0);
  const selectedTab = SOCIAL_MEDIA_TABS[activeTab] || SOCIAL_MEDIA_TABS[0];
  const updateData = (path, value) => onChange?.({ ...data, [path]: value });

  return (
    <div className="social-media-configuration-view">
      <section className="social-media-view-settings">
        <h3>Icon color options for page</h3>
        <div className="social-media-view-radio-fields">
          <IconOptions
            label="Homepage Icons"
            path="homepageIcons"
            value={data?.homepageIcons}
            readOnly={!isEdit}
            onChange={updateData}
          />
          <IconOptions
            label="Profile Icons"
            path="profileIcons"
            value={data?.profileIcons}
            readOnly={!isEdit}
            onChange={updateData}
          />
        </div>
        <div className="social-media-view-text">
          <TextInput
            disabled={!isEdit}
            label="Homepage social media text"
            maxLength={60}
            onUpdate={(value) => updateData("socialMediaText", value)}
            required
            type="text"
            value={data?.socialMediaText}
          />
        </div>
      </section>

      <TabsNavigation
        className="social-media-view-tabs"
        onUpdate={setActiveTab}
        selectedIndex={activeTab}
        style={{ borderBottom: "2px solid #D7E5F8", width: "100%" }}
      >
        {SOCIAL_MEDIA_TABS.map((tab) => (
          <Tab key={tab.dataKey} label={tab.label} />
        ))}
      </TabsNavigation>

      <div className="social-media-view-list">
        <SocialMediaSelectorComponent
          config={{ readonly: !isEdit, inlineEdit: isEdit }}
          data={data?.[selectedTab.dataKey] || {}}
          handleChange={updateData}
          label=""
          path={selectedTab.dataKey}
        />
      </div>
    </div>
  );
};

SocialMediaConfigurationView.propTypes = {
  data: PropTypes.object,
  isEdit: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SocialMediaConfigurationView;
